/**
 * A one-slot mailbox between boot-time native listeners and the screens that
 * act on them (mobile M7). A shortcut or a shared PDF can cold-start the app
 * before any screen exists; the listener puts the event here, and the screen
 * takes it when it mounts — or at once, if it is already listening.
 */

type Listener<T> = (value: T) => void;

export function mailbox<T>() {
  let pending: T[] = [];
  let listener: Listener<T> | null = null;
  return {
    put(value: T) {
      if (listener) listener(value);
      else pending.push(value);
    },
    /** Start receiving; anything that arrived first is delivered now. */
    listen(next: Listener<T>): () => void {
      listener = next;
      const queued = pending;
      pending = [];
      queued.forEach(next);
      return () => {
        if (listener === next) listener = null;
      };
    },
  };
}
